import React, { useEffect, useState } from "react";
import MuiBox from "../MuiBox";
import { TablePagination } from "@mui/material";

const Pagination = ({ pageNo = 1, limit = 10, total = 0, onChange }) => {
  const [page, setPage] = useState(pageNo - 1);
  const [rowsPerPage, setRowsPerPage] = useState(limit);
  
  useEffect(() => {
    setPage(pageNo - 1);
    setRowsPerPage(limit);
  }, [pageNo, limit]);

  useEffect(() => {
    onChange?.(page + 1, rowsPerPage);
  }, [page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <MuiBox>
      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[]}
        sx={{
          "& .MuiTablePagination-toolbar": {
            p: 0,
            minHeight: "fit-content",
          },
          "& .MuiIconButton-root": {
            p: 0,
            color: "text.lightgray",
          },
          "& .MuiTablePagination-displayedRows": {
            color: "text.gray1400",
            fontWeight: "500",
          },
        }}
      />
    </MuiBox>
  );
};

export default Pagination;
